module.exports = __webpack_public_path__ + "static/media/banner_job.43cb721a.png";